<template>
  <div class="padding-10">
    <Toolbar v-if="isAdmin || isDataEntry || isDataEntryAndDispatcher"></Toolbar>
    <Table></Table>
  </div>
</template>
<script>
import Toolbar from "../components/templates/Toolbar";
import Table from "../components/templates/Table";
export default {
  components: {
    Toolbar,
    Table,
  },
  methods: {
    importTemplate() {},
  },
  mounted() {},
};
</script>

<style></style>
